import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ReplyAllSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ReplyAllSVG;
